import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService, MainConfig } from "@atenea-cms";
import { EsportsSlideService, EsportsSlideFormService } from "../shared";

@Component({
  selector: "esports-slide-form",
  templateUrl: "./esports-slide-form.component.html",
  styleUrls: ["./esports-slide-form.component.scss"],
})
export class EsportsSlideFormComponent implements OnInit {
  @Input() id: string;
  @Output() onSave: EventEmitter<string> = new EventEmitter();
  @Output() onDuplicate: EventEmitter<string> = new EventEmitter();
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;
  form: FormGroup;
  modes: Array<Object> = [];
  config: any = {};
  contentsAlign: Array<Object> = [];

  constructor(
    public ft: FormToolsService,
    public dataService: EsportsSlideService,
    public formService: EsportsSlideFormService,
    public mainConfig: MainConfig
  ) {
    this.modes = [
      { value: "img-txt", label: "Imagen - Texto" },
      { value: "txt-img", label: "Texto - Imagen" },
    ];

    this.contentsAlign = [
      { value: "left", label: "Izquierda" },
      { value: "right", label: "Derecha" },
    ];

    this.config = this.mainConfig.modules.esports;
  }

  ngOnInit() {}

  ngOnChanges() {
    this.form = null;

    if (this.id) {
      this.loading = true;

      this.dataService.getById(this.id).subscribe((item) => {
        this.form = this.formService.getForm(item);
        this.loading = false;
      });
    } else {
      setTimeout(() => {
        this.form = this.formService.getForm();
      }, 100);
    }
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/esports-slide-form/esports-slide-form.component.ts